// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
export default {
  defaultProps: {
    fontSize: "inherit",
  },
  styleOverrides: {
    fontSizeInherit: {
      fontSize: "inherit !important",
    },
    fontSizeSmall: {
      fontSize: `${pxToRem(20)} !important`,
    },
    fontSizeLarge: {
      fontSize: `${pxToRem(36)} !important`,
    },
  },
};
